import { render, staticRenderFns } from "./file-download.vue?vue&type=template&id=e9c05ac4&scoped=true"
import script from "./file-download.vue?vue&type=script&lang=js"
export * from "./file-download.vue?vue&type=script&lang=js"
import style0 from "./file-download.vue?vue&type=style&index=0&id=e9c05ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c05ac4",
  null
  
)

export default component.exports